import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { fetchAlertRulesList, removeAlertRule, AlertRuleRow } from '@src/api/alertRules';

export const ALERT_RULES_QUERY_KEY = 'alert-rules-list';

export const useFetchAlertRules = (enabled = true) => {
  const { data, isError, isLoading, refetch } = useQuery(
    [ALERT_RULES_QUERY_KEY],
    (): Promise<{ data: AlertRuleRow[] }> =>
      fetchAlertRulesList().then((response) => response.data),
    {
      refetchOnWindowFocus: false,
      enabled,
      staleTime: 5 * 60 * 1000,
    },
  );

  return { data: data?.data || [], isError, isLoading, refetch };
};

export const useRemoveAlertRule = () => {
  const queryClient = useQueryClient();

  return useMutation((ruleId: number) => removeAlertRule(ruleId), {
    onSuccess: () => {
      queryClient.invalidateQueries([ALERT_RULES_QUERY_KEY]);
      message.success('Rule removed successfully.');
    },
    onError: () => {
      message.error('Failed to remove rule. Please try again.');
    },
  });
};
